import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AppoinmentHistory from "./TemplateForms/AppointmentHistory";
import Treatments from "./TemplateForms/Treatments";
import Layout from "./TemplateForms/Layout";
import Pregnancy from "./TemplateForms/Pregnancy";
import ProgressNotes from "./TemplateForms/ProgressNotes";
import Invoices from "./TemplateForms/Invoices";

import {
  useGetAppointmentHistoryQuery,
  useGetCustomerHistoryQuery,
  useGetPatientCarePackagesQuery,
  useGetPatientInvoiceQuery,
  useGetPregnancyHistoryQuery,
  useGetPrescriptionListQuery,
  useGetProgressNotesHistoryQuery,
  useGetReportsHistoryQuery,
  useGetSpecialNotesHistoryQuery,
  useGetTreatmentHistoryQuery,
} from "../../../../Service/PatientList";
import { useParams } from "react-router-dom";
import SpecialNotes from "./TemplateForms/SpecialNotes";
import Reports from "./TemplateForms/Reports";
import { Change } from "../../../../store/async-actions/digitalmarketing/header";
import CarePackages from "./TemplateForms/CarePackages/CarePackages";
import Prescriptions from "./TemplateForms/Prescription";

const PatientTemplates = () => {
  const [active, setActive] = useState(1);
  const { id } = useParams();
  const [pagination, setPagination] = useState(1);
  const dispatch = useDispatch();

  const { data: CustomerData } = useGetCustomerHistoryQuery(
    { Id: id },
    { refetchOnMountOrArgChange: true }
  );

  // Fetch prescription list data
  const { data: PrescriptionData, refetch: refetchPrescription } =
    useGetPrescriptionListQuery(
      { pageNo: pagination, size: 10, Id: id },
      { refetchOnMountOrArgChange: true }
    );

  // Fetch appointment history data
  const { data: AppointmentData, refetch: refetchAppointment } =
    useGetAppointmentHistoryQuery(
      { Id: id },
      { refetchOnMountOrArgChange: true }
    );

  // Fetch Progress Notes history data
  const { data: ProgressNoteData, refetch: refetchProgressNote } =
    useGetProgressNotesHistoryQuery(
      { Id: id, pageNo: pagination },
      { refetchOnMountOrArgChange: true }
    );

  // Fetch Special Notes history data
  const { data: SpecialNoteData, refetch: refetchSpecialNote } =
    useGetSpecialNotesHistoryQuery(
      { Id: id, pageNo: pagination, size: 10 },
      { refetchOnMountOrArgChange: true }
    );

  // Fetch Reports history data
  const { data: ReportsData, refetch: refetchReports } =
    useGetReportsHistoryQuery(
      { Id: id, pageNo: pagination },
      { refetchOnMountOrArgChange: true }
    );

  // Fetch Treatment history data
  const { data: TreatmentData, refetch: refetchTreatments } =
    useGetTreatmentHistoryQuery(
      { Id: id, pageNo: pagination },
      { refetchOnMountOrArgChange: true }
    );

  // Fetch Pregnancy history data
  const { data: PregnancyData, refetch: refetchPregnancy } =
    useGetPregnancyHistoryQuery(
      { Id: id, pageNo: pagination },
      { refetchOnMountOrArgChange: true }
    );

  // // Fetch Pregnancy history data
  const { data: CarePackageData, refetch: refetchCarePackage } =
    useGetPatientCarePackagesQuery(
      { Id: id },
      { refetchOnMountOrArgChange: true }
    );
  const { data: InvoiceData, refetch: refetchInvoiceData } =
    useGetPatientInvoiceQuery({ Id: id }, { refetchOnMountOrArgChange: true });
  useEffect(() => {
    const data: any = {
      first: `${CustomerData?.data?.customerName}`,
    };
    dispatch(Change(data));
  }, [CustomerData, active]);

  return (
    <Layout
      active={active}
      setActive={setActive}
      customerId={id as string}
      CustomerData={CustomerData?.data}
    >
      {() => (
        <>
          {active === 1 && (
            <AppoinmentHistory AppointmentData={AppointmentData} />
          )}
          {/* {active === 2 && (
            <Treatments
              TreatmentData={TreatmentData}
              refetchTreatments={refetchTreatments}
            />
          )} */}
          {active === 3 && (
            <Pregnancy
              PregnancyData={PregnancyData}
              refetchPregnancy={refetchPregnancy}
            />
          )}
          {active === 4 && <Prescriptions />}
          {active === 5 && (
            <ProgressNotes
              ProgressNoteData={ProgressNoteData}
              pagination={pagination}
              setPagination={setPagination}
              refetch={refetchProgressNote}
            />
          )}
          {active === 6 && <SpecialNotes SpecialNoteData={SpecialNoteData} />}
          {active === 7 && (
            <Reports ReportsData={ReportsData} refetch={refetchReports} />
          )}
          {active === 8 && <Invoices />}
          {active === 9 && (
            <CarePackages
              CarePackageData={CarePackageData}
              refetchCarePackage={refetchCarePackage}
            />
          )}
          {/* {active === 10 && <FollicularStudyForm />} */}
        </>
      )}
    </Layout>
  );
};

export default PatientTemplates;
